export enum ValidationClientGroup {
    PERSONAL_DATA = 'D',
    PROFESSIONAL_DATA = 'P',
    PUBLIC_DATA = 'F',
}
